import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import TradeVolumeChart from '../../components/charts/TradeVolumeChart';
import { Button } from '../../components/ui/button';
import StatsCard from '../../components/common/StatsCard';
import PageHeader from '../../components/common/PageHeader';
import KYCAlert from '../../components/kyc/KYCAlert';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import toast from 'react-hot-toast';
import { USER_ROUTES } from '../../constants/routeConstants';

const ClientDashboard = () => {
  const { updateUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const tradeData = [
    { date: '2024-01-01', volume: 150000, trades: 45 },
    { date: '2024-01-02', volume: 180000, trades: 52 },
    { date: '2024-01-03', volume: 120000, trades: 38 },
    { date: '2024-01-04', volume: 200000, trades: 61 },
    { date: '2024-01-05', volume: 170000, trades: 48 },
  ];
  const handleNewTradeNavigate = () => {
    navigate(USER_ROUTES.USER_ACCOUNT_MY_TRADES);
  };
  const handleDepositFundNavigate = () => {
    navigate(USER_ROUTES.USER_DEPOSIT);
  };
  const handleWithdrawNavigate = () => {
    navigate(USER_ROUTES.USER_WITHDRAWAL);
  };
  useEffect(() => {
    const fetchProfileAndUpdateStorage = async () => {
      try {
        setLoading(true);
        const storedUser = localStorage.getItem('user');
        if (!storedUser) {
          console.error('No user found in localStorage');
          return;
        }

        const userObj = JSON.parse(storedUser);
        const userId = userObj.id || userObj._id || userObj.userId;
        if (!userId) {
          console.error('No user ID found in stored user data');
          return;
        }
        const profileResponse = await authAPI.getProfile(userId);
        if (profileResponse) {
          const completeUserData = {
            ...profileResponse,
            verification: profileResponse.verification || null,
            bankDetails: profileResponse.bankDetails || null,
          };
          localStorage.setItem('user', JSON.stringify(completeUserData));
          updateUser(completeUserData);
        }
      } catch (error: any) {
        toast.error(error.message || 'Failed to fetch profile data');
      } finally {
        setLoading(false);
      }
    };
    fetchProfileAndUpdateStorage();
  }, [updateUser]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="relative">
      <KYCAlert />
      <div className="sticky top-0 z-20 bg-background pt-4">
        <PageHeader
          title="Dashboard"
          description="Overview of your Forex CRM system"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 my-4">
        <StatsCard title="Account Balance" value="$50,000.00" />
        <StatsCard title="Equity" value="$52,350.00" />
        <StatsCard title="Margin Used" value="$2,350.00" />
        <StatsCard title="Free Margin" value="$47,650.00" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>Recent Activity</CardTitle>
          </CardHeader>
          <CardContent>
            <TradeVolumeChart data={tradeData} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Quick Actions</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button
              variant="outline"
              className="w-full"
              onClick={handleNewTradeNavigate}
            >
              New Trade
            </Button>
            <Button
              variant="outline"
              className="w-full"
              onClick={handleDepositFundNavigate}
            >
              Deposit Funds
            </Button>
            <Button
              variant="outline"
              className="w-full"
              onClick={handleWithdrawNavigate}
            >
              Withdraw Funds
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ClientDashboard;
